
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import ExpertiseSelector from "../../../common/expertise/selector/ExpertiseSelector";

export default function FieldExpertise({ profile, onChange, isDesktop }) {
	const [expertises, setExpertises] = useState([]);
	const [activeExpertiseIds, setActiveExpertiseIds] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchExpertises();
	}, []);

	function fetchExpertises() {
		api.listDoctorExpertises({
			profile_id: profile.id,
		})
			.then((result) => {
				if (result["all_expertises"] && result["active_expertises"]) {
					let ids = result["active_expertises"].map((expertise) => expertise.id);
					setActiveExpertiseIds(ids);
					setExpertises(result["all_expertises"]);
					onChange(ids);
				}
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	return (
		<div className="rounded-xl border border-[#E2E8F0] p-4">
			<h2 className="font-Vazir-700 text-[15px] text-darkBlue text-center pb-2 mb-3 border-b border-[#E2E8F0]">
				تخصص‌ها
			</h2>
			{expertises.length > 0 ? (
				<ExpertiseSelector
					expertises={expertises}
					initActiveExpertiseIds={activeExpertiseIds}
					onChange={onChange}
					isDesktop={isDesktop}
				/>
			) : (
				<p className="text-center font-Vazir-400 text-[14px] text-grayText py-4">
					در حال بارگذاری تخصص‌ها…
				</p>
			)}
			{errorMessage ? (
				<p className="text-center font-Vazir-400 text-[14px] text-error mt-3">{errorMessage}</p>
			) : null}
		</div>
	);
}
